import { Component, OnInit, Input, ElementRef, ChangeDetectorRef, ViewEncapsulation } from "@angular/core";
import { EventPreferencesService, EventPreferences, Item, Group } from "../../../services/event.preferences.service";
import { MultiselectModelI } from "../../s25-multiselect/s25.multiselect.component";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { S25Util } from "../../../util/s25-util";
import { S25ItemI } from "../../../pojo/S25ItemI";
import { Debounce } from "../../../decorators/debounce.decorator";
import { SearchCriteria } from "../../../pojo/SearchCriteria";
import StepType = SearchCriteria.StepType;
import { S25MultiselectSearchCriteriaComponent } from "../../s25-multiselect/multiselects/s25.multiselect.search.criteria.component";
@TypeManagerDecorator("s25-ng-ev-prefs")
@Component({
    selector: "s25-ng-ev-prefs",
    template: `
        @if (init) {
            <div class="ev-prefs-wrapper">
                <div class="evdo-panel">
                    <div class="s25-panel-head">
                        <div class="ngBold">
                            Event Preferences
                            @if (profileName && !profileName.includes("Rsrv_")) {
                                {{ " " + profileName }}
                            }
                        </div>
                        <span class="c-margin-right--half">
                            @if (isExpand) {
                                <button (click)="editToggle()" class="c-textButton">
                                    {{ isEdit ? "View" : "Edit" }}
                                </button>
                            }
                            <div
                                class="toggle-prefs-button"
                                role="button"
                                tabindex="0"
                                [class.expanded]="isExpand"
                                (click)="expandToggle()"
                                (keydown.enter)="expandToggle()"
                            >
                                <s25-ng-icon [type]="'caretUp'"></s25-ng-icon>
                            </div>
                        </span>
                    </div>
                    @if (isExpand) {
                        <div class="pref-panel">
                            @if (preference?.panelId) {
                                <div>
                                    @if (
                                        !featureItem?.item.length &&
                                        !partitionItem?.item.length &&
                                        !locationItem?.item.length &&
                                        !resourceItem?.item.length &&
                                        !isEdit
                                    ) {
                                        <span> (none) </span>
                                    }
                                    @for (item of itemList; track item) {
                                        <div>
                                            @if (this[item.itemName]?.item?.length > 0 || isEdit) {
                                                <div>
                                                    <div class="ngBold">{{ item.displayName }}</div>
                                                    @for (
                                                        item of this[item.itemName]?.item;
                                                        track item + "-" + i;
                                                        let i = $index
                                                    ) {
                                                        <div class="c-margin-left--single c-margin-bottom--quarter">
                                                            {{ item.itemName }}
                                                            @if (item.quantity) {
                                                                <span>[Quantity: {{ item.quantity }}]</span>
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            }
                                            @if (isEdit) {
                                                <div class="buttons adj-line-height c-margin-bottom--half">
                                                    @if (!this[item.itemName]?.item) {
                                                        <div class="c-margin-bottom--quarter">(none)</div>
                                                    }
                                                    <s25-ng-multiselect-search-criteria
                                                        #multiselect
                                                        [modelBean]="this[item.bean]"
                                                        [selectedItems]="this[item.itemName]?.item"
                                                        [popoverOnBody]="true"
                                                        [type]="item.type"
                                                    ></s25-ng-multiselect-search-criteria>
                                                    @if (this[item.itemName]?.item?.length > 0) {
                                                        <button
                                                            class="aw-button aw-button--outline c-margin-left--single"
                                                            (click)="onClear(item, multiselect)"
                                                        >
                                                            Clear
                                                        </button>
                                                    }
                                                </div>
                                            }
                                        </div>
                                    }
                                    @if (!preference?.panelId) {
                                        <div>None</div>
                                    }
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        }
    `,
    styles: [
        `
            .ev-prefs-wrapper {
                margin-bottom: 20px;

                .evdo-panel {
                    padding: unset;
                    border: unset;

                    .s25-panel-head {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        background-color: #f3f3f3;

                        span {
                            display: flex;
                        }

                        .c-textButton {
                            font-size: 1rem;
                        }
                    }

                    .pref-panel {
                        font-size: 0.9rem;
                        padding: 1rem;
                        border-inline: 1px solid rgba(0, 0, 0, 0.15);
                    }
                }
            }

            ::ng-deep .toggle-prefs-button svg {
                transition: transform 0.3s;
            }

            ::ng-deep .toggle-prefs-button.expanded svg {
                transform: rotate(180deg) scaleX(-1);
            }

            ::ng-deep .nm-party--on .ev-prefs-wrapper .evdo-panel .pref-panel {
                background-color: #3c3d46;
                border-inline: unset;
            }

            ::ng-deep .nm-party--on .ev-prefs-wrapper .evdo-panel {
                background-color: #3c3d46;
                border-inline: unset;
                border-bottom: unset !important;
            }

            ::ng-deep .nm-party--on .ev-prefs-wrapper {
                border: 1px solid rgba(255, 255, 255, 0.24);
                border-radius: 3px;
            }
        `,
    ],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false,
})
export class S25EventPreferencesComponent implements OnInit {
    @Input() eventId?: number;
    @Input() type: string = "location";
    @Input() profileName?: string;
    @Input() profileId?: number;

    isExpand: boolean = false;
    isEdit: boolean = false;
    init: boolean = false;
    preference: EventPreferences;

    modelBean = { showResult: false, showMatching: true };
    featureBean: MultiselectModelI = { buttonText: "Edit", buttonClass: "aw-button--primary" };
    partitionBean: MultiselectModelI = { buttonText: "Edit", buttonClass: "aw-button--primary" };
    locationBean: MultiselectModelI = { buttonText: "Edit", buttonClass: "aw-button--primary" };
    resourceBean: MultiselectModelI = { buttonText: "Edit", buttonClass: "aw-button--primary" }; //MultiselectModelI; //SearchCriteriaContextI;

    itemList = [
        {
            objectId: StepType.Location.Features,
            objectType: "feature",
            displayName: "Features:",
            itemName: "featureItem",
            type: "locationFeatures",
            action: "editFeature",
            bean: "featureBean",
        },
        {
            objectId: StepType.Location.Partitions,
            objectType: "partition",
            displayName: "Partitions:",
            itemName: "partitionItem",
            type: "locationPartitions",
            action: "editPartition",
            bean: "partitionBean",
        },
        {
            objectId: StepType.Location.Spaces,
            objectType: "location",
            displayName: "Locations:",
            itemName: "locationItem",
            type: "locations",
            action: "editLocation",
            bean: "locationBean",
        },
        {
            objectId: StepType.Resource.Resources,
            objectType: "resource",
            displayName: "Resources:",
            itemName: "resourceItem",
            type: "resourcesQuantity",
            action: "editResource",
            bean: "resourceBean",
        },
    ] as const;
    featureItem: Group;
    partitionItem: Group;
    locationItem: Group;
    resourceItem: Group;

    constructor(private cd: ChangeDetectorRef) {}

    async ngOnInit() {
        const data = await EventPreferencesService.getPreferences(this.eventId);

        this.preference = data?.panel?.find((panel) => panel.panelId === this.profileId);
        this.preference ??= { panelId: this.profileId, group: [] };

        this.featureBean.action = this.editFeature;
        this.partitionBean.action = this.editPartition;
        this.locationBean.action = this.editLocation;
        this.resourceBean.action = this.editResource;

        this.featureItem = await this.itemFilter(StepType.Location.Features);
        this.partitionItem = await this.itemFilter(StepType.Location.Partitions);
        this.locationItem = await this.itemFilter(StepType.Location.Spaces);
        this.resourceItem = await this.itemFilter(StepType.Resource.Resources);

        // All filtered displays items
        this.locationBean.items = this.locationItem?.item || [];
        this.resourceBean.items = this.resourceItem?.item || [];

        this.init = true;
        this.cd.detectChanges();
    }

    expandToggle() {
        this.isExpand = !this.isExpand;
        this.isEdit = false;
        this.cd.detectChanges();
    }

    editToggle() {
        this.isEdit = !this.isEdit;
        this.cd.detectChanges();
    }

    async onClear(item: (typeof this.itemList)[number], multiselect: S25MultiselectSearchCriteriaComponent) {
        let find = this.preference.group.filter((g: Group) => {
            return g.typeId === item.objectId;
        });

        // ANG-4541 updated item with empty [] instead of call delete method
        const ok = await EventPreferencesService.putPreferences(
            this.eventId,
            this.preference.panelId,
            item.objectId,
            find[0]?.queryId,
            [],
        ).catch(this.error);

        if (ok) {
            multiselect.selectNone();
            this.ngOnInit();
            this.cd.detectChanges();
        }
    }

    editFeature = () => {
        this.editSelectedActions(StepType.Location.Features, this.featureBean.selectedItems);
    };

    editPartition = () => {
        this.editSelectedActions(StepType.Location.Partitions, this.partitionBean.selectedItems);
    };

    editLocation = () => {
        this.editSelectedActions(StepType.Location.Spaces, this.locationBean.selectedItems);
    };

    editResource = () => {
        this.resourceBean.selectedItems = this.resourceBean.selectedItems.map((item: S25ItemI) => ({
            itemId: item.itemId,
            itemName: item.itemName,
            checked: true,
            quantityMax: item.quantityMax,
            quantity: item.quantity || 1,
            quantitySrc: item.quantitySrc || 1,
        }));
        this.editSelectedActions(StepType.Resource.Resources, this.resourceBean.selectedItems);
    };

    @Debounce(300)
    async editSelectedActions(typeId: number, items: S25ItemI[]) {
        let find = this.preference.group.filter((g: Group) => {
            return g.typeId === typeId;
        });

        const putItems: Pick<Item, "itemId" | "quantity">[] = items.map((item) => ({
            itemId: Number(item.itemId),
            quantity: item.quantity,
        }));

        const ok = await EventPreferencesService.putPreferences(
            this.eventId,
            this.preference.panelId,
            typeId,
            find[0]?.queryId,
            putItems,
        ).catch(this.error);
        if (ok) {
            this.ngOnInit();
            this.cd.detectChanges();
        }
    }

    itemFilter(typeId: number): Group {
        if (this.preference?.group) {
            let find = this.preference.group.filter((g: Group) => {
                return g.typeId === typeId;
            });

            if (find.length > 0) {
                return find[0];
            } else {
                return;
            }
        } else {
            return;
        }
    }

    error(error: unknown) {
        S25Util.showError(error);
    }
}
